import { useState } from "react";

import { useNavigate } from "react-router-dom";

import backendClient from "src/api";
import { useAuthRedirect } from "src/experiences/auth/hooks/redirect";
import useUser from "src/hooks/useUser";

export const useAzureSSO = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { logUserIn } = useUser();
  const { redirectAfterLogin } = useAuthRedirect();

  const initiateAzureSSO = async () => {
    setLoading(true);
    try {
      const url = await backendClient.auth.getAzureSsoLoginUrl();
      // Preserve the current stored redirect path before navigating away
      window.location.href = url;
    } catch (error) {
      console.error("Failed to initiate Azure SSO:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAzureSSOCallback = async (authResponse: object) => {
    setLoading(true);
    try {
      const tokenPayload = await backendClient.auth.azureSsoCallback({
        auth_response: authResponse,
      });
      logUserIn(tokenPayload);
      redirectAfterLogin();
    } catch (error) {
      console.error("Azure SSO callback failed:", error);
      navigate("/login", { state: { error: "Azure SSO login failed" } });
    } finally {
      setLoading(false);
    }
  };

  return { initiateAzureSSO, handleAzureSSOCallback, loading };
};
